import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommonService} from '../../../core/service/common.service';
import {KeishaOperator, KeishaOperatorEdit} from '../../interfaces/keisha';

@Component({
  selector: 'app-keisha-sub-dialog',
  templateUrl: './keisha-sub-dialog.component.html',
  styleUrls: ['./keisha-sub-dialog.component.scss']
})
export class KeishaSubDialogComponent implements OnInit {
  public meisai: KeishaOperator;
  constructor(@Inject(MAT_DIALOG_DATA) public data: KeishaOperator,
              public commonService: CommonService,
              public matDialogRef: MatDialogRef<KeishaSubDialogComponent>,) {
    this.meisai = this.data;
  }

  /**
   *
   */
  ngOnInit(): void {
  }
}
